import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { StrategyPickComponent } from 'src/app/pages/strategy/strategy-pick/strategy-pick.component';
import { ModelStrategyCarouselModule } from 'src/app/shared/model-strategy-carousel/model-strategy-carousel.module';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { StrategyRoutingModule } from './strategy-picker-routing.module';


@NgModule({
  declarations: [
    StrategyPickComponent,
  ],
  imports: [
    CommonModule,
    PreloadSpinnerModule,
    ModelStrategyCarouselModule,
    TranslateModule,
    AngularSvgIconModule,
    ButtonModule,
    StrategyRoutingModule,
  ],
  exports: [
    StrategyPickComponent,
  ],
})
export class StrategyPickerModule { }
